<template>
  <gj-modal
      :visible.sync="modalVisible"
      size="table"
      no-padding
      :footer="false">
    <template #header>
      <span>操作日志</span><span class="modal-secondary-title">{{ item.keywordText }}</span>
    </template>
    <template #content>
      <div style="height: 100%; padding: 0 10px;">
        <gj-table
            ref="gjTable"
            :index="false"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :pagination="pagination"
            :adapt-height="false"
            :height="410"
            @page-change="$gjNoticeQuery">
        </gj-table>
      </div>
    </template>
  </gj-modal>
</template>

<script>
  import {modalMixIn, queryMixin} from "@/minxins";
  import {getAdsAdjustStrategyLog} from "../../../../../../../api/ad";
  import {defaultVal, isMeaningful} from "../../../../../../../utils/common";
  import {mapGetters} from "vuex";
  import {AdStrategyEnum} from "../../../../strategy/common/enum";
  import {AdPlacementEnum, AdTargetEnum} from "../../../../common/enum";

  export default {
    name: "app-strategy-adjust-log-modal",
    mixins: [modalMixIn, queryMixin],
    props: {
      item: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'localUpdateDate', header: '时间', field: 'localUpdateDate', minWidth: '150px'},
          {id: 'objectType', header: '操作类型', field: 'option:objectType', minWidth: '100px', options: AdStrategyEnum.opTypeOption},
          {id: 'content', header: '调整记录', field: 'content', minWidth: '300px'},
        ]
      }
    },
    computed: {
      ...mapGetters({
        marketOption: 'marketOption'
      }),
    },
    methods: {
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: defaultVal(this.item.marketId, null),
            campaignId: defaultVal(this.item.campaignId, null),
            groupId: defaultVal(this.item.groupId, null),
            keywordId: defaultVal(this.item.keywordId, null),
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getAdsAdjustStrategyLog(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            }
          })
          .complete(() => {
            this.loading = false;
          });
      }
    }
  }
</script>

<style scoped>

</style>

